import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "onduty-svg-recstop",
  "use": "onduty-svg-recstop-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"onduty-svg-recstop\"><path fill=\"#d81e06\" d=\"M194.08 186.08l640 0 0 640-640 0 0-640Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol